import { createModuleStateSelector } from '@americanexpress/travel-selectors';
import { MODULE_NAME } from '../constants/modules';

const getModuleStateSelector = createModuleStateSelector(MODULE_NAME);

export default getModuleStateSelector;
